import { BrowserRouter, Routes, Route } from 'react-router-dom';  
import { AuthProvider } from './contexts/AuthContext';  
import Login from './components/Login';  
import XCallback from './components/XCallback';  
import Dashboard from './components/Dashboard';  
import { ProtectedRoute } from './components/ProtectedRoute';  
  
export default function App() {  
  return (  
    <AuthProvider>  
      <BrowserRouter>  
        <Routes>  
          <Route path="/login" element={<Login />} />  
          <Route path="/xcallback" element={<XCallback />} />  
          <Route   
            path="/dashboard"   
            element={  
              <ProtectedRoute>  
                <Dashboard />  
              </ProtectedRoute>  
            }   
          />  
        </Routes>  
      </BrowserRouter>  
    </AuthProvider>  
  );  
}